import React, { useMemo } from 'react';

// DEPENDENCIES
import lowerCase from 'lodash/lowerCase';

// FUNCTIONS
import { checkRole } from 'functions.js';

// GLOBAL COMPONENTS
import Page from 'parts/page/Page';

// LOCAL COMPONENTS
import OrderButton from '../tools/OrderButton';
import DeliveredButton from '../tools/DeliveredButton';
import FalloutSidebar from '../tools/FalloutSidebar/FalloutSidebar';
import ReviveButton from '../tools/ReviveButton';
import AMFinanceButton from '../tools/AMFinanceButton';
import PushToTTMSButton from '../tools/PushToTTMSButton';
import PrintButton from '../../../tools/PrintSelectButton';

// MAIN COMPONENT
const AMFinanceButtons = ({ record, isFinanceManager }) => {
  const {
    inventory: { stock_num } = {},
    customer_first_name,
    customer_last_name,
    daily_sales_inventory_id,
    sales_id,
    sales_status_name,
    sales_time
  } = record || {};
  const customerName = `${customer_first_name} ${customer_last_name}`;

  const status = useMemo(() => lowerCase(sales_status_name), [sales_status_name]);

  const isAdminOrSalesManager = checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus']);

  const isDelivered = status === 'delivered';
  const isFallout = status === 'fallout';
  const isOrdered = status === 'order';

  return (
    <Page.Buttons>
      <PrintButton
        dailySalesInventoryId={daily_sales_inventory_id}
        salesId={sales_id}
        customerName={customerName}
        stockNum={stock_num}
        isFallout={isFallout}
      />
      {!isFinanceManager && (
        <>
          <OrderButton disabled={isFallout || isOrdered} />
          <DeliveredButton
            salesTime={sales_time}
            customerName={customerName}
            stockNum={stock_num}
            disabled={isDelivered || isFallout || isOrdered}
          />
          <FalloutSidebar.Button disabled={isFallout} />
          {isFallout && <ReviveButton />}
          {isOrdered && <AMFinanceButton customerName={customerName} stockNum={stock_num} />}
        </>
      )}
      {isAdminOrSalesManager && isOrdered && <PushToTTMSButton />}
    </Page.Buttons>
  );
};

// EXPORT
export default AMFinanceButtons;
